<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout column align-center justify-center>
        <img v-if='themeSwitch' src="@/assets/logo.png" alt="Vuetify.js" class="mb-1">
        <img v-else src="@/assets/logoBlack.png" alt="Vuetify.js" class="mb-1">
        <div>
          <v-icon @click="$router.push('/projects')" style="font-size: 30px; cursor: pointer; margin: 15px;">public</v-icon>
          <v-icon @click="$router.push('/users')" style="font-size: 30px; cursor: pointer; margin: 15px;">people</v-icon>
          <v-icon @click="$router.push('/roles')" style="font-size: 30px; cursor: pointer; margin: 15px;">device_hub</v-icon>
          <v-icon @click="$router.push('/gnipRules')" style="font-size: 30px; cursor: pointer; margin: 15px;">playlist_add</v-icon>
          <v-icon @click="$router.push('/custom-reports')" style="font-size: 30px; cursor: pointer; margin: 15px;">folder_open</v-icon>
        </div>

        <v-container fill-height hide-overflow>
          <div style="position: relative; width: 100%; height: 75%; background-color: transparent !important;">
            <div style="position: absolute; top: 0; right: 0; bottom: 0; left: 0; transition-duration: 1s; background-color: transparent !important;" 
              :style="showCloudProgress && cloudProgress? cloudProgressStyle : {}">
              
              <vue-word-cloud :progress.sync="cloudProgress" :words="cloudWords">
                <template slot-scope="word">
                  <v-tooltip top>
                    <div slot="activator" style="cursor: pointer;" @click="">{{ word.text }}</div>
                    <div style="text-align: center;">{{ word.text }}<br/>({{ word.weight }})</div>
                  </v-tooltip>
                </template>				
              </vue-word-cloud>
			</div>
			
			<transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOut">
			  <v-progress-circular v-if="showCloudProgress && cloudProgress" 
			    style="position: absolute; top: 0; right: 0; bottom: 0; left: 0; margin: auto; background-color: transparent !important;"
			    :value="(cloudProgress.completedWords / cloudProgress.totalWords) * 100"
			    :size="150"
			    :width="10" 
			    :rotate="-90">
			    {{ cloudProgress.completedWords }} of {{ cloudProgress.totalWords }}
			  </v-progress-circular>
			</transition>
		  </div>
		</v-container>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.container, .column {
  height: 100%;
}
</style>

<script>
import VueWordCloud from 'vuewordcloud'
import { mapGetters } from 'vuex'
import { generateRandomCloudWords } from '@/helpers/formatters'

export default {
  data: function () {
    return {
      showCloudProgress: true,
      cloudProgress: null
    }
  },
  asyncComputed: {
    async cloudWords () {
      try {
        const response = await this.$store.dispatch('getUsersWordCloud')
        const data = await response.data
        if (data.status !== 'SUCCESS' || !data.payload) return generateRandomCloudWords()
        return Object.entries(data.payload).map(([key, value]) => ([key, value]))
      } catch (err) {
        return generateRandomCloudWords()
      }
    }
  },
  computed: {
    ...mapGetters({
      themeSwitch: 'getTheme'
    }),
    cloudProgressStyle: function () {
      return {
        pointerEvents: 'none',
        opacity: 0.3,
        transform: 'scale(0.7, 0.7)',
        'background-color': 'transparent'
      }
    }
  },
  watch: {
    cloudProgress: function (currentCloudProgress, previousCloudProgress) {
      if (previousCloudProgress) {
        this.showCloudProgress = false
      }
    }
  },
  components: {
    [VueWordCloud.name]: VueWordCloud
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Home.vue